// UNCOMMENT THIS WHEN UPDATED REACT VERSION MORE THAN 18.3.1

// import React from 'react';
// import { renderWithProviders } from '@app/__tests_configs__/test-utils';
// import { ENV_KA, ENV_PS } from '@app/__tests_configs__/constants';
// import ContextRenderer from '../context_renderer';

// // const renderComponent = (name = 'mbw_colors') => (
// //   renderWithProviders(<ContextRenderer componentName={ name } params={ {} } />, {
// //     preloadedState: {
// //       user: {
// //         user: {
// //           id: 1,
// //           xfmProgram: { credits: 3 },
// //           nickname: 'Test User'
// //         }
// //       }
// //     }
// //   })
// // );

describe('MBW Colors', () => {
  it('test styles for pg', async () => {
    // await renderComponent();
    // const styles = getComputedStyle(document.documentElement);
    // expect(styles.getPropertyValue('--app-color')).toBe('#8F63EC');
    // expect(styles.getPropertyValue('--background-secondary')).toBe('#F7F7F7');
    // expect(styles.getPropertyValue('--border-primary')).toBe('#EAEAEA');
    // expect(styles.getPropertyValue('--mbw-text-primary')).toBe('#121212');
  });
  // it('test styles for ka', async () => {
  //   global.process.env.APP_CONTEXTS = ENV_KA;
  //   await renderComponent();
  //   const styles = getComputedStyle(document.documentElement);
  //   expect(styles.getPropertyValue('--app-color')).toBe('#6C84FF');
  //   expect(styles.getPropertyValue('--background-secondary')).toBe('#F2F5FF');
  //   expect(styles.getPropertyValue('--border-primary')).toBe('#DFE2EF');
  //   expect(styles.getPropertyValue('--mbw-text-primary')).toBe('#121212');
  // });
  // it('test styles for ps', async () => {
  //   global.process.env.APP_CONTEXTS = ENV_PS;
  //   await renderComponent();
  //   const styles = getComputedStyle(document.documentElement);
  //   expect(styles.getPropertyValue('--app-color')).toBe('#B45092');
  //   expect(styles.getPropertyValue('--background-secondary')).toBe('#F7F7F7');
  //   expect(styles.getPropertyValue('--border-primary')).toBe('#E1E1E1');
  //   expect(styles.getPropertyValue('--mbw-text-primary')).toBe('#121212');
  // });
});
